import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/use-auth'
import { LoadingScreen } from '@/components/ui/loading-screen'

interface RoleGuardProps {
  allowed: string[]
  children: React.ReactNode
}

/**
 * Route-level role guard. Shows a loading screen while auth is initializing,
 * then redirects to dashboard if user's role is not in the allowed list.
 */
export function RoleGuard({ allowed, children }: RoleGuardProps) {
  const { user, isLoading } = useAuth()

  // Don't redirect while auth is still loading — prevents flickering
  if (isLoading) {
    return <LoadingScreen />
  }

  const role = user?.primary_role || user?.roles?.[0] || ''

  if (!role || !allowed.includes(role)) {
    return <Navigate to="/app/dashboard" replace />
  }

  return <>{children}</>
}
